import {platform} from 'onsenui';

export default function() {
  return platform.isChrome() || platform.isSafari() || platform.isFirefox() || platform.isOpera() || platform.isEdge() || platform.isIE();
}



// WEBPACK FOOTER //
// ./src/utils/isBrowser.js